function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27 7.04c-12.979 0-23.5 10.521-23.5 23.5s10.521 23.5 23.5 23.5 23.5-10.521 23.5-23.5S39.979 7.04 27 7.04z",
  strokeLinecap: "square",
  strokeMiterlimit: 3.962
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5 13.54a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM28.5 48.04a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 9.04c-11.736 0-21.25 9.626-21.25 21.5s9.514 21.5 21.25 21.5 21.25-9.626 21.25-21.5S38.736 9.04 27 9.04z",
  strokeLinecap: "square",
  strokeMiterlimit: 3.962
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  transform: "translate(3 6.54)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.25 25.75a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM6.75 25.75a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM39.689 16.924a1.5 1.5 0 11-1.5-2.598 1.5 1.5 0 011.5 2.598zM9.811 34.174a1.5 1.5 0 11-1.5-2.598 1.5 1.5 0 011.5 2.598zM8.311 16.924a1.5 1.5 0 101.5-2.598 1.5 1.5 0 00-1.5 2.598zM38.189 34.174a1.5 1.5 0 101.5-2.598 1.5 1.5 0 00-1.5 2.598zM33.924 10.061a1.5 1.5 0 11-2.598-1.5 1.5 1.5 0 012.598 1.5zM16.674 39.939a1.5 1.5 0 11-2.598-1.5 1.5 1.5 0 012.598 1.5zM14.076 10.061a1.5 1.5 0 102.598-1.5 1.5 1.5 0 00-2.598 1.5zM31.326 39.939a1.5 1.5 0 102.598-1.5 1.5 1.5 0 00-2.598 1.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 23.071,
  y: 12,
  width: 1.929,
  height: 13.009,
  rx: 0.964,
  ry: 0.929,
  strokeMiterlimit: 3.962
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.219 12.188a.903.903 0 00-.375.094c-.463.257-.614.872-.313 1.375l6.532 10.906c.301.503.943.695 1.406.437.108-.06.18-.156.25-.25-.174.168-.42.25-.688.25-.534 0-.968-.391-.968-.906v-3.281l-4.844-8.063c-.226-.377-.618-.592-1-.562zm7.5 12.562a.722.722 0 00.063-.094c-.023.028-.037.07-.063.094z",
  strokeMiterlimit: 3.962
})));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Clock.1c14ac59.svg";
export { ForwardRef as ReactComponent };